import { Fragment } from "react";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const NotFoundPage = props => {
    const { t } = useTranslation();
    return (
        <Fragment>
            <div className="notfound-page">
                <div style={{display: "flex", height: "100%", justifyContent: "center", alignItems: "center"}}>
                    <h1>{t("notfound.notfound")}</h1>
                </div>
            </div>
            <style>
                {
                    `
                        .notfound-page
                        {
                            display: flex;
                            height: 100%;
                            align-items: center;
                            flex: 1;
                            justify-content: center;
                            position: relative;
                            background-color: transparent;
                        }
                    `
                }
            </style>
        </Fragment>
    );
};

//export const NotFoundPage = {Component: NotFound};